module.exports = __webpack_public_path__ + "22d3eba0982cdfb559702eabec2480ee.MP3";